<template lang="html">
  <li
    :class="{'divider':divider}"
    :style="{
      'color':hoverx?giveColor()+' !important':null,
      'background':hoverx?giveColor(.01)+' !important':null
    }"
    class="vs-component vs-dropdown--item"
    @click="closeParent"
    @mouseout="hoverx=false"
    @mouseover="hoverx=true">
    <router-link
      v-if="to"
      v-bind="$attrs"
      :class="{'disabled':disabled}"
      :to="to"
      class="vs-dropdown--item-link"
      v-on="$listeners">
      {{$attrs.disabled}}
      <slot></slot>
    </router-link>

    <a
      v-else
      v-bind="$attrs"
      :class="{'disabled':disabled}"
      class="vs-dropdown--item-link"
      v-on="$listeners">
      <slot></slot>
    </a>
  </li>
</template>

<script>
  import _color from '../../utils/color.js';

  export default {
    name: 'VsDropdownItem',
    inheritAttrs: false,
    props: {
      to: [Object, String],
      disabled: Boolean,
      divider: Boolean,
    },
    data: () => ({
      hoverx: false,
      vsDropDownItem: true,
      color: null,
    }),
    mounted() {
      this.changeColor();
    },
    updated() {
      this.changeColor();
    },
    methods: {
      closeParent() {
        if (this.disabled) return;
        searchParent(this);

        function searchParent(_this) {
          const parent = _this.$parent;
          if (!parent.$el.className) return;
          if (parent.$el.className.indexOf('parent-dropdown') === -1) {
            searchParent(parent);
          } else {
            const [dropdownMenu] = parent.$children.filter(item => {
              return item.hasOwnProperty('dropdownVisible');
            });
            dropdownMenu.dropdownVisible = parent.vsDropdownVisible = false;
          }
        }
      },
      changeColor() {
        const _self = this;
        searchParent(this);

        function searchParent(_this) {
          const parent = _this.$parent;
          if (!parent.$el.className) {
            return;
          }
          if (parent.$el.className.indexOf('parent-dropdown') === -1) {
            searchParent(parent);
          } else {
            _self.color = parent.color;
          }
        }
      },
      giveColor(opacity = 1) {
        return _color.rColor(this.color, opacity);
      },
    },
  };
</script>
